<template>
    <div>
        <a class="me-2" @click.stop @click="openFeedbackModal">
            <i class="fa fa-comment fa-lg text-primary"></i>
        </a>

        <div class="modal fade" ref="feedbackModal" id="feedbackModal" tabindex="-1" aria-hidden="true" @click.stop>
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="block-rounded block-transparent mb-0 block">
                        <!-- Header -->
                        <div class="block-header block-header-default">
                            <h3 class="block-title">
                                Feedback for {{ shipment.reference }}
                            </h3>
                            <div class="block-options">
                                <button type="button" class="btn-block-option" data-bs-dismiss="modal"
                                    aria-label="Close">
                                    <i class="fa fa-fw fa-times"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Content -->
                        <div class="block-content text-start fs-sm mb-4">
                            <!-- Unreachable Toggle -->
                            <div class="form-check form-switch mb-2">
                                <input class="form-check-input" type="checkbox" id="unreachable"
                                    v-model="unreachable" />
                                <label class="form-check-label" for="unreachable">
                                    {{ $t('placeholder_is_unreachable') }}
                                </label>
                            </div>

                            <!-- Evading Toggle -->
                            <div class="form-check form-switch mb-3">
                                <input class="form-check-input" type="checkbox" id="evading" v-model="evading" />
                                <label class="form-check-label" for="evading">
                                    {{ $t('placeholder_is_evading') }}
                                </label>
                            </div>

                            <!-- Feedback Textarea -->
                            <div class="mb-2">
                                <textarea id="feedback-content" class="form-control" v-model="feedbackContent"
                                    rows="4"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="block-content block-content-full bg-body text-end">
                        <button type="button" class="btn btn-sm btn-alt-secondary me-1"
                            data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="submitFeedback">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'PhoneCallsModal',
    props: {
        shipment: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            unreachable: false,
            evading: false,
            feedbackContent: '',
            modalInstance: null
        }
    },
    mounted() {
        this.modalInstance = new bootstrap.Modal(this.$refs.feedbackModal);
    },
    methods: {
        openFeedbackModal() {
            this.modalInstance.show();
        },
        async submitFeedback() {
            try {
                const payload = {
                    shipment_id: this.shipment._id,
                };

                // Only include fields if they have values
                if (this.feedbackContent) payload.feedback_content = this.feedbackContent;
                if (this.unreachable) payload.unreachable = true;
                if (this.evading) payload.evading = true;

                const response = await axios.post('/shipments/post-feedback', payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    },
                });

                if (response.data.error) {
                    this.showErrorNotification(response.data.error);
                } else {
                    this.feedbackContent = '';
                    this.unreachable = false;
                    this.evading = false;
                    this.modalInstance.hide();
                    Swal.fire({
                        icon: 'success',
                        title: 'Feedback submitted successfully',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            } catch (error) {
                console.error(error);
                this.modalInstance.hide();

                if (error.response?.data?.errors) {
                    const messages = Object.values(error.response.data.errors).flat().join('\n');
                    this.showErrorNotification(messages);
                } else {
                    this.showErrorNotification('An error occurred while submitting feedback.');
                }
            }
        },
        showErrorNotification(message) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,
            });
        }
    }
}
</script>